/**
 * WithdrawDoneOverlay — 탈퇴 완료 화면 (Figma 2023:13782).
 *
 * 탈퇴 성공 직후 전체 화면을 덮는 안내 오버레이. ActivityHost 의 appbar 까지 가리도록
 * fixed + 높은 z-index 로 body 에 portal. TEMPLATE 로고 appbar + 중앙 안내 문구만 노출.
 *
 * 노출 후 3초 뒤 `onFinish` 호출 (auth clear + 홈 복귀). onFinish 가 리렌더로 매번
 * 바뀌어도 타이머가 리셋되지 않도록 ref 로 고정하고 effect deps 는 비운다.
 */
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import BrandWordmark from "../../components/layout/BrandWordmark";
import styles from './WithdrawDoneOverlay.module.css';

const REDIRECT_DELAY_MS = 3000;

interface WithdrawDoneOverlayProps {
  /** 3초 경과 후 호출 — auth clear + 홈 화면 이동. */
  onFinish: () => void;
}

export default function WithdrawDoneOverlay({ onFinish }: WithdrawDoneOverlayProps) {
  const { t } = useTranslation('app');
  const onFinishRef = useRef(onFinish);
  onFinishRef.current = onFinish;

  useEffect(() => {
    const timer = window.setTimeout(() => onFinishRef.current(), REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return createPortal(
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label={t('withdraw.doneAria')}>
      <div className={styles.appbar}>
        <BrandWordmark height={22} />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{t('withdraw.doneTitle')}</p>
        {/* 줄바꿈은 문구(app:withdraw.doneThanks)의 \n — .desc 가 white-space: pre-line */}
        <p className={styles.desc}>{t('withdraw.doneThanks')}</p>
      </div>
    </div>,
    document.body,
  );
}
